var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAddParticipants = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a_add_p{\n                fill: none !important;\n            }\n\n            .b_add_p {\n                fill: #fff;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a_add_p",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b_add_p",
    d: "M5129,9744v-2c0-2.661,5.331-4,8-4s8,1.34,8,4v2Zm1.714-1.587h12.464c.262-.878-1.411-2.678-6.177-2.773l-.318,0C5132.154,9739.637,5130.422,9741.665,5130.713,9742.413Zm15.355-3.414v-3H5143v-1.819h3.069V9731h1.819v3.182H5151V9736h-3.113v3Zm-13.325-6a4,4,0,1,1,4,4A4,4,0,0,1,5132.743,9733Zm1.45,0a2.551,2.551,0,1,0,2.55-2.551A2.553,2.553,0,0,0,5134.193,9733Z",
    transform: "translate(-5128 -9724)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAddParticipants);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_add_participants.0f7fdd0213b652e77e47f45d0424a1b4.svg";